export default "__VITE_ASSET__35d4868e__"